module.exports = "img/icon-email-user.af133ff.svg";